<script>
import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';

export default {
  props: {
    campaignId: String,
  },
  mixins: [clientMixins],
  data: () => ({
    privileged: false
  }),
  created() {
    if (!this.campaignId && this.hasPrivilege(privileges.ORDERS)) {
      this.privileged = true;
    } else if (this.campaignId && this.hasPrivilege(privileges.CAMPAIGN_ORDERS)) {
      this.privileged = true;
    } else {
      this.$router.replace('/');
    }
  },
};
</script>

<template lang='pug'>
router-view(v-if='privileged')
</template>

<style>
@import '~import/index';
@import '~styles/index';

.orders {
  @extend %content-margin;
}
</style>